import { render } from "./Addtravel.vue?vue&type=template&id=394f3cad&scoped=true"
import script from "./Addtravel.vue?vue&type=script&lang=js"
export * from "./Addtravel.vue?vue&type=script&lang=js"

import "./Addtravel.vue?vue&type=style&index=0&id=394f3cad&lang=scss&scoped=true"
import "./Addtravel.vue?vue&type=style&index=1&id=394f3cad&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394f3cad"]])

export default __exports__